export const CancelNotAvailableModal: string = 'CancelNotAvailableModal';
